import { jsx as m } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as i } from "../../../context/theme/hooks.js";
import p from "../../../utils/colorWithOpacity/index.js";
import "../../layout/Stack/Stack.js";
import e from "../../layout/Box/Box.js";
import "react";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
function k({ position: o, onCloseClick: r }) {
  const t = i();
  return /* @__PURE__ */ m(
    e,
    {
      position: o,
      top: "0",
      left: "0",
      height: "100%",
      width: "100%",
      onClick: r,
      backgroundColor: p(t["modal-overlay"], 0.6)
    }
  );
}
export {
  k as default
};
